import { getLoginLinkClickAction } from 'client/utils/login';
import useLoginWindowPostMessage from 'client/hooks/login/useLoginWindowPostMessage';

export default function useLoginLinkClickAction({ loginUrl, afterLoginRedirectUrl = '' }) {
    const { windowRef } = useLoginWindowPostMessage({ redirectUrl: afterLoginRedirectUrl });

    return getLoginLinkClickAction(windowRef, loginUrl);
}
